import { request } from '@/utils/request'

const prefix = '/auth-api'

export function auth() {
  return request.get(`${prefix}/auth`)
}